export const replaceMagicFields = (titleWithMagicFields: string, data: Dict<string>): string => {
  const lettersArray: string[] = titleWithMagicFields?.split('') ?? [];
  const magicFields: string[] = [];
  let startIndex: number;

  lettersArray.forEach((letter, index, arr) => {
    if (letter === '$' && arr[index + 1] === '{') {
      startIndex = index + 1;
    }

    if (letter === '}') {
      magicFields.push(titleWithMagicFields.substr(startIndex + 1, index - startIndex - 1));
    }
  });

  let titleWithData = titleWithMagicFields;
  for (let i = 0; i < magicFields.length; i++) {
    const fieldName = magicFields[i];
    // eslint-disable-next-line prefer-template
    const magicField = '${' + fieldName + '}';
    titleWithData = titleWithData.replace(magicField, data[fieldName] ?? '');
  }

  return titleWithData;
};

interface IApiTicketHolder {
  active: boolean;
  barcode: string;
  credentialProfileId: string;
  credentialStatus: string;
  email: string;
  eventId: string;
  externalId: string;
  firstName: string;
  jobId: number;
  lastName: string;
  memberId: string;
  projectId: string;
  status: string;
  ticketHolderId: number;
  ticketNumbers: string;
}

export const createTicketHolderModelMock = (
  values: Dict<any> & {
    credentialProfileId: string | null;
    projectId: string | null;
    eventId: string | null;
    accreditationRequestId: string | null;
  },
): IApiTicketHolder => ({
  active: true,
  credentialStatus: 'any',
  externalId: 'any',
  jobId: 0,
  status: 'any',
  barcode: `QR:${values.accreditationRequestId ?? ''}`,
  credentialProfileId: values.credentialProfileId ?? 'any',
  email: values.email ?? '',
  eventId: values.eventId ?? '',
  firstName: values.firstName ?? '',
  lastName: values.lastName ?? '',
  memberId: values.accreditationRequestId ?? '',
  projectId: values.projectId ?? '',
  ticketHolderId: values.accreditationRequestId ? parseInt(values.accreditationRequestId, 10) : 0,
  ticketNumbers: values.accreditationRequestId ?? '0',
});
